// extracted by mini-css-extract-plugin
export default {"header":"EditShowName_header__6wYBb","icon":"EditShowName_icon__N0Ucu"};